<template>
  <div class="myorder">
    <GlobTopNav title="订单列表" :rightHidden="false"> </GlobTopNav>

    <div class="van-content">
      <div class="van-hairline--top-bottom van-tabbar">
        <div class="van-tabbar-item" :class="this.$route.name == 'AllOrder' ? 'active' : ''">
          <router-link to="/user/myorder/allorder/?type=0" tag="div" class="van-tabbar-item__text">
            全部
          </router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'PayOrder' ? 'active' : ''">
          <router-link to="/user/myorder/payorder?type=1" tag="div" class="van-tabbar-item__text">
            待支付
          </router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'SendOrder' ? 'active' : ''">
          <router-link to="/user/myorder/sendorder?type=2" tag="div" class="van-tabbar-item__text">
            待发货
          </router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'TakeOrder' ? 'active' : ''">
          <router-link to="/user/myorder/takeorder?type=3" tag="div" class="van-tabbar-item__text">
            已发货
          </router-link>
        </div>
        <div class="van-tabbar-item" :class="this.$route.name == 'FinishOrder' ? 'active' : ''">
          <router-link
            to="/user/myorder/finishorder?type=4"
            tag="div"
            class="van-tabbar-item__text"
          >
            已取消
          </router-link>
        </div>
      </div>

      <!-- <Allorder></Allorder> -->
      <!--<keep-alive>-->
      <router-view></router-view>
      <!--</keep-alive>-->
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/topnav'
export default {
  name: 'index',
  components: {
    TopNav
  },
  data() {
    return {
      datas: [],
      page: 0
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'User' })
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    }
  },
  mounted() {}
}
</script>

<style lang="less">
.myorder {
  background-color: #f5f5f5;
  .van-content {
    padding-bottom: 0;
    margin-top: 0.96rem;
    .goodsonelist {
      margin: 0;
      background-color: #f5f5f5;
      margin-bottom: 0.05rem;
    }
    .van-cell-group {
      margin-top: 0.1rem;
      background-color: #fff;
    }
    .van-tabbar {
      position: fixed;
      top: 0.96rem;
      z-index: 1;

      .van-tabbar-item {
        .van-tabbar-item__text {
          font-size: 0.28rem;
          font-weight: 400;
          color: #262626;
          line-height: 0.48rem;
        }
      }

      .active {
        .van-tabbar-item__text {
          font-size: 0.3rem;
          font-weight: bold;
        }
        border-bottom: 0.04rem solid #fb4141;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/myorder.vue